<template>
  <v-dialog
    :value="active"
    max-width="850"
    @input="$emit('update:active', $event)">
    <v-card>
      <div class="grey lighten-3 _fs-20 _fs-sm-24 pa-4">
        สำหรับลูกค้าที่ชำระเงินผ่าน Agency เจ้าอื่น
      </div>

      <div class="pa-4">
        <!-- eslint-disable-next-line max-len -->
        <div>1.   ทาง  Sellsuki จะมีการตัดรอบการเข้า Agency <b class="error--text"><u>ทุกๆวันที่ 15 ของทุกเดือน</u></b></div>
        <div class="error--text">
          (หากชำระเงินช้ากว่าวันดังกล่าว  ระบบจะตัดรอบการย้ายบัญชีไปรอบเดือนถัดไปทันที)
        </div>
        <!-- eslint-disable-next-line max-len -->
        <div>2.   กรุณาแจ้ง <b><u>Agency เดิม</u></b> ให้เปลี่ยนเป็น Plan Free ก่อนที่จะทำการย้ายเข้า Sellsuki Agency <span class="error--text">(สามารถแจ้งได้ทันที)</span></div>
        <!-- eslint-disable-next-line max-len -->
        <div>3.   หลังจากดำเนินการนำบัญชีเข้าระบบ Agency เสร็จสิ้นแล้ว บัญชีของท่านจึงจะสามารถใช้งานแพ็กเกจตามที่สั่งซื้อได้</div>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="grey--text"
          text
          @click="$emit('cancel')">
          ปิด
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="$emit('accept')">
          ยอมรับ
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderOtherAgency',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
